import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import PressureConverter from '../components/tools/PressureConverter';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'PSI to Bar Calculator | Pressure Unit Converter | AUTOXIUM';
const PAGE_DESCRIPTION = 'Convert pressure instantly between psi, bar, kPa, and atm. Free online pressure calculator for tire, hydraulic, and boost pressure conversions, with formulas and adjustable precision.';

const PressureConverterPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="pressure-converter-page">
      <PageHero
        eyebrow="Engineering Utilities / Conversion"
        title="PSI ↔ Bar Calculator"
        description="Convert pressure between Pounds per Square Inch, Bar, Kilopascals, and Standard Atmosphere. Enter a value in any unit and the rest update in real time."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="pressure-converter-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <PressureConverter />
          <ToolGuideCta guidePath="/tools/pressure-calculator/guide" toolName="PSI ↔ Bar Calculator" />
        </div>
      </section>
    </div>
  );
};

export default PressureConverterPage;
